export enum Currency {
    AUD = 'AUD'
}